/**
 * @generated SignedSource<<2aa34a817664178988974e7a64851046>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
import { FragmentRefs } from "relay-runtime";
export type ActionItemIntegrationsStreamIntegration$data = {
  readonly actionItemIntegration: {
    readonly id: string;
    readonly integrationProvider: IntegrationProvider;
    readonly integrationSpecificDetails: {
      readonly " $fragmentSpreads": FragmentRefs<"clickupStreamDetails" | "linearStreamDetails" | "mondayStreamDetails" | "trelloStreamDetails">;
    };
  } | null;
  readonly asanaStream: {
    readonly " $fragmentSpreads": FragmentRefs<"asanaStreamDetails">;
  } | null;
  readonly " $fragmentType": "ActionItemIntegrationsStreamIntegration";
};
export type ActionItemIntegrationsStreamIntegration$key = {
  readonly " $data"?: ActionItemIntegrationsStreamIntegration$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionItemIntegrationsStreamIntegration">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActionItemIntegrationsStreamIntegration",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StreamActionItemIntegrationNode",
      "kind": "LinkedField",
      "name": "actionItemIntegration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "integrationProvider",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "integrationSpecificDetails",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "clickupStreamDetails"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "trelloStreamDetails"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "mondayStreamDetails"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "linearStreamDetails"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AsanaStreamNode",
      "kind": "LinkedField",
      "name": "asanaStream",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "asanaStreamDetails"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};

(node as any).hash = "297028df0b66e66ab5adfba51a480777";

export default node;
